
import React, { Fragment } from 'react';
import MainNavigation from '../MainNavigation';
import MainFooter from '../MainFooter';
import classes from './PrivacyPolicy.module.css';
import { FaWhatsapp, FaEnvelope, FaShieldAlt, FaDatabase, FaServer, FaLock, FaPhoneAlt } from 'react-icons/fa';

const PrivacyPolicy = () => {
    return (
        <Fragment>
            <MainNavigation />
            <div className={classes.container}>
                <header className={classes.hero}>
                    <div className="container">
                        <h1>Privacy Policy</h1>
                        <p>Effective Date: February 12, 2026 | Last Updated: February 12, 2026</p>
                    </div>
                </header>

                <main className={classes.content}>
                    <section className={classes.section}>
                        <h2>1. Introduction</h2>
                        <p>
                            Welcome to <span className={classes.highlight}>Dr Tech Buddy</span>, a premier Hospital Management System
                            developed and operated by <strong>Invensoft Solutions</strong>. We are deeply committed to protecting
                            the privacy and security of the data processed through our platform.
                        </p>
                        <p>
                            This Privacy Policy outlines how we handle personal data in strict compliance with
                            India’s <strong>Digital Personal Data Protection (DPDP) Act, 2023</strong> and the
                            <strong>Digital Personal Data Protection Rules, 2025</strong>.
                        </p>
                    </section>

                    <section className={classes.section}>
                        <h2>2. Our Roles Under the DPDP Act</h2>
                        <div className={classes.subSection}>
                            <h3>A. Client Data (You are the Data Fiduciary)</h3>
                            <p>
                                When hospitals, doctors, or administrators visit our website, sign up, or pay for services,
                                we collect business information to manage accounts and billing.
                            </p>
                            <ul>
                                <li><strong>Data Collected:</strong> Name, Email, Phone Number, Hospital Name, Billing Address.</li>
                                <li><strong>Purpose:</strong> Account management, billing, and technical support.</li>
                            </ul>
                        </div>
                        <div className={classes.subSection}>
                            <h3>B. Patient Data (You are the Data Processor)</h3>
                            <p>
                                When a hospital uses our software to store patient records, the <span className={classes.highlight}>Hospital is the Data Fiduciary</span>,
                                and we act strictly as the <strong>Data Processor</strong>.
                            </p>
                            <ul>
                                <li><strong>Data Processed:</strong> Patient names, health records, medical history, and treatments.</li>
                                <li><strong>Responsibility:</strong> We do not own this data. The Hospital is solely responsible for obtaining patient consent under the DPDP Act.</li>
                            </ul>
                        </div>
                    </section>

                    <section className={classes.section}>
                        <h2>3. How We Store & Secure Data</h2>
                        <p>We employ a robust 3-tier architecture with strict data isolation to ensure maximum security.</p>
                        <div className={classes.storageGrid}>
                            <div className={classes.storageCard}>
                                <FaDatabase style={{ fontSize: '2rem', color: '#006d77', marginBottom: '10px' }} />
                                <h4>Data Isolation</h4>
                                <p>Every hospital is assigned a separate, completely isolated database.</p>
                            </div>
                            <div className={classes.storageCard}>
                                <FaServer style={{ fontSize: '2rem', color: '#006d77', marginBottom: '10px' }} />
                                <h4>Cloud Hosting</h4>
                                <p>All data is hosted on secure Cloud Platform within India. We do not transfer health data across borders.</p>
                            </div>
                            <div className={classes.storageCard}>
                                <FaLock style={{ fontSize: '2rem', color: '#006d77', marginBottom: '10px' }} />
                                <h4>Encryption</h4>
                                <p>Data is encrypted in transit (SSL/TLS) and secured at rest using industry standards.</p>
                            </div>
                        </div>
                    </section>

                    <section className={classes.section}>
                        <h2>4. Data Retention and Deletion</h2>
                        <p><strong>Client Data:</strong> Retained as long as subscription is active and per Indian tax laws.</p>
                        <p><strong>Patient Data:</strong> Retained only during subscription. Upon termination:</p>
                        <ol>
                            <li>We provide a full downloadable export of the hospital's data.</li>
                            <li>We permanently delete the Hospital's separate database from our Cloud within 60 days of contract termination.</li>
                        </ol>
                    </section>

                    <section className={classes.section}>
                        <h2>5. Your Rights</h2>
                        <p>As a Data Principal, you have the right to:</p>
                        <ul>
                            <li>Access personal data we hold about your account.</li>
                            <li>Request correction of inaccurate details.</li>
                            <li>Withdraw consent for marketing communications.</li>
                        </ul>
                    </section>

                    <section className={classes.section}>
                        <h2>6. Disclosure to Third Parties</h2>
                        <p>
                            We <strong>do not sell or trade</strong> personal data. We may share data only with
                            legal authorities if required by Indian law or a valid court order.
                        </p>
                    </section>

                    <section className={classes.section}>
                        <h2>7. Grievance Redressal</h2>
                        <p>For questions or grievances, contact our Data Protection Officer (DPO):</p>
                        <div className={classes.contactSection}>
                            <div className={classes.contactInfo}>
                                <p><strong>Entity:</strong> Invensoft Solutions</p>
                                <p><strong>Address:</strong> Katraj, Pune, Maharashtra, 411046</p>
                                <p><strong>Phone:</strong> 7559383489</p>
                                <p><strong>Email:</strong> ajay.nigade19@gmail.com</p>
                            </div>
                            <div className={classes.actions}>
                                <a href="https://wa.me/917559383489" target="_blank" rel="noopener noreferrer" className={`${classes.button} ${classes.whatsapp}`}>
                                    <FaWhatsapp size={20} /> Chat on WhatsApp
                                </a>
                                <a href="tel:7559383489" className={`${classes.button} ${classes.call}`}>
                                    <FaPhoneAlt size={20} /> Call Us
                                </a>
                                <a href="mailto:ajay.nigade19@gmail.com" className={`${classes.button} ${classes.email}`}>
                                    <FaEnvelope size={20} /> Send an Email
                                </a>
                            </div>
                        </div>
                    </section>
                </main>
            </div>
            <MainFooter />
        </Fragment>
    );
};

export default PrivacyPolicy;
